<template lang="pug">
section.popup
  .popup__overlay
  .popup__view
    .popup__body
      .popup__close(@click="close")
        icon(name="close")
      .popup__header {{$t('returnPopup.ticketsReturn')}}
      .popup__main
        .return
          template(v-if="!access")
            .return__row(v-if="returnInfo && returnInfo.isReturnable")
              .return-info
                .return-warning(v-if="returnInfo.confirm") {{returnInfo.confirm}}
                .sum {{$t('returnPopup.refund')}}
                  | : <b>{{(returnInfo.returnableSum/ 100).toFixed(2)}} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}</b>
                .serv-sum {{$t('returnPopup.fee')}}
                  | : {{(returnInfo.comissionSum / 100).toFixed(2)}} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}
                  label.checkbox.popup__checkbox
                    input(type="checkbox", v-model="userAccess")
                    span.checkbox__text
                      span {{$t('msgs.acceptTerms')}}&nbsp;
                      a(href="https://24guru.by/ru/pages/contract-offer", target="_blank")
                        | {{$t('msgs.terms')}}
                .button-access
                  button.button.button_primary(:disabled="!userAccess", @click="access=true;")
                    | {{$t('returnPopup.returnConfirm')}}
            .return__row(v-if="returnInfo && !returnInfo.isReturnable")
              .return-info
                .sum(v-html="returnInfo.comment", v-if="returnInfo.comment && returnInfo.comment.length")
                .sum(v-else) {{$t('returnPopup.noRefund')}}
            .return__row(v-if="!returnInfo")
              .text-center
                spiner
          .return__row(v-if="returnInfo && (access || !returnInfo.isReturnable)")
            //- BALANCE
            .return_col(v-if="returnInfo.methods.hasOwnProperty('balance')")
              i.return__balance
              .return-title {{$t('returnPopup.returnAmount')}}
              ul
                li(v-if="isAfishaDomain")
                  span {{$t('returnPopup.equalTen')}}
                li
                  span {{$t('returnPopup.expirationDate')}}
                li
                  span {{$t('returnPopup.payWebsite')}}
                li
                  span {{$t('returnPopup.equivalent')}}
              button.button.button_primary-outline(v-if="returnInfo.methods.balance && !isLoading",
              @click="returnTicket('balance')") {{$t('returnPopup.addPoints')}}

            //- ORG TICKETS
            .return_col(v-if="returnInfo.methods.hasOwnProperty('organizator')")
              tempalte(v-if="ticket && ticket.session && ticket.session.isReturnOrganizer == 1")
                i.return__card
                .return-title
                  | {{$t('returnPopup.refundOrg')}}
                  | {{$t('returnPopup.contactOrg')}}
                ul
                  li
                    span {{$t('returnPopup.organizer')}}: {{ticket.session.company.name}}
                  li
                    span {{$t('profileSettings.address')}}: {{ticket.session.company.address}}
                  li
                    span Email: {{ticket.session.company.email}}
                  li
                    span {{$t('returnPopup.telephone')}}: {{ticket.session.company.phone1}}

            //- CARD
            .return_col(v-if="returnInfo.methods.hasOwnProperty('card')")
              template
                i.return__card
                .return-title {{$t('returnPopup.returnBank')}}
                ul
                  //- li
                  //-   span Для возврата на банковскую карту обратитесь в техподдержку
                  li
                    span {{$t('returnPopup.refundPeriod')}}
                  li
                    span {{$t('returnPopup.equivalent')}}
              button.button.button_primary-outline(v-if="returnInfo.methods.card && !isLoading",
              @click="returnTicket('card')") {{$t('returnPopup.returnToCard')}}
              .noreturn(v-else)
                | {{$t('returnPopup.returnSupport')}}
                a(href="mailto:support@24afisha.by") &nbsp;support@24afisha.by
          .return__row(v-if="isLoading")
            .text-center
              spiner

        .popup__footer.text-center
          .row(v-if="access")
            a.terms(href="https://24guru.by/ru/pages/offer-contract") {{$t('msgs.terms')}}
  transition(name="fade" mode="out-in")
    vb-alert(v-model="isReturned", @resolve="cancel", @close="cancel")
      template(#title) {{$t('returnPopup.ticketReturn')}}
      template() {{msg}}
</template>

<script>
import { mapGetters } from 'vuex';
import icon from '@/components/Icons.vue';
import Spiner from '@/components/Spiner.vue';
import API from '@/api/api';

export default {
  props: ['orderId', 'ticket', 'type'],
  data() {
    return {
      isReturned: false,
      returnInfo: null,
      msg: null,
      access: false,
      userAccess: false,
      isLoading: false,
      isAfishaDomain: true,
    };
  },
  components: {
    icon,
    Spiner,
  },
  computed: {
    ...mapGetters({
      getLayout: 'getLayout',
    }),
  },
  mounted() {
    if (window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;
    this.getInfo();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async returnTicket(type) {
      this.isLoading = true;
      let data;
      if (this.ticket && this.ticket.id) {
        data = await API.returnTicket(this.orderId, this.ticket.id, this.type || 'tickets', type,
          (error) => {
            this.isLoading = false;
            global.console.error(error);
            const { response: { data } = {} } = error;
            const [msg] = data.errors;
            global.alert(msg);
          });
      } else {
        data = await API.returnOrder(this.orderId, type, (error) => {
          this.isLoading = false;
          global.console.error(error);
          const { response: { data } = {} } = error;
          const [msg] = data.errors;
          global.alert(msg);
        });
      }
      if (data) {
        this.isLoading = false;
        this.msg = data.message;
        this.isReturned = true;
      }
    },
    cancel() {
      this.$emit('onReturn');
    },
    async getInfo() {
      let data;
      if (this.ticket && this.ticket.id) {
        data = await API.returnTicketInfo(this.orderId, this.type || 'tickets', this.ticket.id);
      } else {
        data = await API.returnInfo(this.orderId);
      }
      if (data) {
        this.returnInfo = data;
        // console.log(123);
        // this.returnInfo.isReturnable = false;
      }
    },
  },
};
</script>

<style lang="scss">
.return{
  max-width: 550px;
  &__row{
    display: flex;
  }
  &_col{
    position: relative;
    padding-right: 1rem;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    i{
      position: absolute;
      top: 0;
      left: 0;
      margin-bottom: 2rem;
      width: 70px;
      height: 50px;
    }
    i.return__balance{
      background: url('../../../../../common/assets/img/return_balance.png') no-repeat;
    }
    i.return__card{
      left: 1rem;
      background: url('../../../../../common/assets/img/return_card.png') no-repeat 0 .8rem;
    }
    .return-title{
      margin-top: 60px;
      font-size: 14px;
      line-height: 16px;
      font-weight: 600;
      padding-bottom: 1rem;
    }
    ul{
      padding-left: 1rem;
      list-style-type: disc;
      font-size: 12px;
      li{
        padding-bottom: 1rem;
        line-height: 16px;
        color: #ffcf0c;
        span{
          color: #151515;
        }
      }
    }
  }
  &_col+&_col {
    padding-left: 1rem;
    border-left: 1px solid #aaa;
  }
  &-info {
    width: 100%;
    padding-bottom: 1rem;
    .return-warning {
      color: red;
      padding-bottom: .5rem;
    }
    .sum {
      padding-bottom: .5rem;
    }
    .serv-sum {
      font-size: .8rem;
    }
  }
}
.terms{
  padding-top: 1rem;
}
.noreturn{
  padding: 1rem;
  font-size: 12px;
  line-height: 16px;
}
.button-access {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 0 0;
}
.text-center{
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
